'use client';

import React from 'react';

export const usePreviousRef = <T extends unknown>(value: T): React.MutableRefObject<T | undefined> => {
  const ref = React.useRef<T | undefined>(undefined);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
};
